import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getNewsItems } from "../../api/api";
import { INews } from "../../types/news";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap";
import { t } from 'i18next';

const News = ({ limit = 3 }) => {
  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery("NewsData", () =>
    getNewsItems({ limit, language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading) return <div></div>;
  if (error) return <div></div>;
  return (

    <Card className="mb-4">
      <Card.Header>{t('news_showcase.header')}</Card.Header>
    
      <Card.Body>

      <Row xs={1} md={3} className="g-4 d-flex align-items-stretch">
  {data.data.map((newsItem: INews) => (
    <NewsItem key={newsItem.id} data={newsItem} />
  ))}
</Row>
    </Card.Body>

     
    </Card>


   
  );
};

interface ISNewsItemProps {
  data: INews;
}

const formatText = (text: string) => {
  if (!text) return ''; // Return an empty string if text is null or undefined

  return text.replace(/(\d+)/g, '<span class="en_font">$1</span>');
};


const NewsItem = ({ data }: ISNewsItemProps) => {
  return (
    <NewsCol>
    <SLink to={`/news-list/${data.id}`}>
      <StyledCard className="shadow ">
      <CardImage
  variant="top"
  src={`${process.env.REACT_APP_CMS}${data?.attributes.Images?.data?.[0]?.attributes?.url ?? ''}`}
/>
     <CardTextContainer>
     <CardTitle dangerouslySetInnerHTML={{ __html: formatText(data.attributes.Title) }} />
     <Card.Text dangerouslySetInnerHTML={{ __html: formatText(data.attributes.SubTitle) }} />
        </CardTextContainer>
      </StyledCard>
    </SLink>
  </NewsCol>
  );
};


// Styled component for cards to ensure uniform size
const StyledCard = styled(Card)`
  height: 100%; // Make cards take full height of the column
`;

// Styled component for card images to ensure uniform size and aspect ratio
const CardImage = styled(Card.Img)`
  height: 180px; // Fixed height
  object-fit: cover; // Cover the space without distorting the image
`;

// Ensure the Card's text container also fits well
const CardTextContainer = styled(Card.Body)`
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled(Card.Title)`
  flex-grow: 1; // Allows the title to expand and push the subtitle to the bottom
`;

// Ensures that all columns are the same height
const NewsCol = styled(Col)`
  display: flex;
`;

const SLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  flex-grow: 1; // Ensures the link takes the full space of the column for consistent styling
`;

// const Icon = styled.img`
//   width: 60px;
// `;

export default News;
